import { CaseReducer } from '@reduxjs/toolkit';
import { RefreshFilterState } from './refresh.types';

export const createRefreshFilterCaseReducer =
  <State extends RefreshFilterState>(): CaseReducer<State> =>
  (state) => {
    state.refresh += 1;
  };
